var $4b247c3a68c0be9b$exports = {};
$4b247c3a68c0be9b$exports = {
    "collectionLabel": `\u{5019}\u{88DC}`
};


export {$4b247c3a68c0be9b$exports as default};
//# sourceMappingURL=ja-JP.mjs.map
